import { ref, onMounted, onUnmounted } from 'vue'

export function useScrollSpy(sectionIds: string[], offset = 100) {
  const activeSection = ref('')

  let observer: IntersectionObserver | null = null

  function setup() {
    const visibleSections = new Map<string, number>()

    observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            visibleSections.set(entry.target.id, entry.intersectionRatio)
          } else {
            visibleSections.delete(entry.target.id)
          }
        }

        let maxRatio = 0
        let topSection = ''
        for (const [id, ratio] of visibleSections) {
          if (ratio > maxRatio) {
            maxRatio = ratio
            topSection = id
          }
        }

        if (topSection) {
          activeSection.value = topSection
        }
      },
      {
        rootMargin: `-${offset}px 0px -40% 0px`,
        threshold: [0, 0.25, 0.5, 0.75, 1],
      }
    )

    for (const id of sectionIds) {
      const el = document.getElementById(id)
      if (el) observer.observe(el)
    }
  }

  onMounted(() => {
    requestAnimationFrame(setup)
  })

  onUnmounted(() => {
    observer?.disconnect()
  })

  return { activeSection }
}
